/* GET THE LOOK carousel — strzałki prev/next przewijają track (scroll-snap). */
class GetTheLookCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gtlc-track]');
    this.querySelector('[data-gtlc-prev]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-gtlc-next]')?.addEventListener('click', () => this.move(1));
  }
  move(dir) {
    if (!this.track) return;
    this.track.scrollBy({ left: this.track.clientWidth * 0.8 * dir, behavior: 'smooth' });
  }
}
if (!customElements.get('get-the-look-carousel')) {
  customElements.define('get-the-look-carousel', GetTheLookCarousel);
}
